import { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { setPlanLinePriority } from "@/lib/api";

// Inline editable priority number for a plan line (works before and after the RM is bound).
export const LinePriorityEdit = ({ planId, line, idx, onSaved }) => {
  const [val, setVal] = useState(line.priority_no ?? "");
  useEffect(() => setVal(line.priority_no ?? ""), [line.priority_no]);

  const mut = useMutation({
    mutationFn: (no) => setPlanLinePriority(planId, line.line_id, no),
    onSuccess: (d) => { toast.success(d.priority_no ? `Priority set to ${d.priority_no}` : "Priority cleared"); onSaved(); },
    onError: (e) => { toast.error(e?.response?.data?.detail || "Couldn't change priority"); setVal(line.priority_no ?? ""); },
  });

  const commit = () => {
    const no = val === "" ? null : parseInt(val, 10);
    if (no !== null && (!Number.isFinite(no) || no < 1)) { toast.error("Priority must be 1 or more"); setVal(line.priority_no ?? ""); return; }
    if (no !== (line.priority_no ?? null)) mut.mutate(no);
  };

  return (
    <label className="inline-flex items-center gap-1 text-[10px] tracking-wider uppercase font-bold px-1.5 py-0.5 rounded-sm bg-slate-900 text-white">
      Priority
      <input
        data-testid={`detail-line-${idx}-priority-input`}
        type="number"
        min={1}
        value={val}
        disabled={mut.isPending}
        onChange={(e) => setVal(e.target.value)}
        onBlur={commit}
        onKeyDown={(e) => { if (e.key === "Enter") e.currentTarget.blur(); }}
        placeholder="—"
        className="w-12 h-5 px-1 rounded-sm bg-white text-slate-900 font-mono text-xs text-center outline-none focus:ring-2 focus:ring-amber-400"
      />
    </label>
  );
};
